import moment from 'moment'
import { formatter, revenueFormatter } from './practiceIQConsts'
import { GRAY_500 } from '../../../scss/colorConsts'

export function getChartOptions(showTooltipLabel, type) {
  return {
    elements: {
      line: {
        tension: 0.4,
      },
      point: {
        radius: 0,
        hitRadius: 10,
        hoverRadius: 4,
        hoverBorderWidth: 3,
      },
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function () {
            return ''
          },
          label: showTooltipLabel
            ? function (context) {
                let label = ''
                if (context.parsed.x !== null) {
                  label =
                    type === 'Revenue'
                      ? revenueFormatter.format(parseFloat(context.parsed.y).toFixed(2))
                      : formatter.format(parseFloat(context.parsed.y).toFixed(2))
                }
                return label
              }
            : undefined,
        },
      },
    },
    scales: {
      x: {
        display: true,
        stacked: true,
        ticks: {
          color: GRAY_500,
        },
      },
      y: {
        display: true,
        stacked: true,
        ticks: {
          color: GRAY_500,
        },
      },
    },
  }
}

export const currentMonth = moment().format('YYYY-MM')
export const currentYear = moment().format('YYYY')
export const today = moment().format('YYYY-MM-DD')
export const calendarDropDownData = [
  {
    id: currentMonth,
    name: `Current Month`,
  },
  {
    id: 'This week',
    name: `Current Week`,
  },
  {
    id: currentYear,
    name: `Current Year`,
  },
  {
    id: 'Previous month',
    name: `Last Month`,
  },
  {
    id: 'Previous week',
    name: `Last Week`,
  },
  {
    id: 'previousyear',
    name: `Last Year`,
  },

  {
    id: 'custom',
    name: `Custom`,
  },
  // {
  //   id: 'Select period...',
  //   name: `Select period...`,
  // },
]

export const graphBarColors = [
  '#78ACAC',
  '#6D5D94',
  '#875DE6',
  '#5414DD',
  '#C62F2F',
  '#065535',
  '#40e0d0',
  '#ffa500',
  '#ff7373',
  '#133337',
  '#FF00FF',
  '#00FF00',
  '#FFFF00',
  '#ab0068',
  '#fa7445',
  '#626a4c',
  '#7b5c62',
  '#e08dff',
  '#0909FA',
  '#385750',
  '#63E2C4',
  '#26822F',
  '#67B76F',
  '#0F3F30',
  '#01EFA7',
  '#3372EF',
  '#032771',
  '#5E0B78',
  '#4657C1',
  '#C1B146',
  '#8DB5B9',
  '#DB8599',
  '#7AE6D1',
  '#E67E7A',
  '#F67873',
  '#759300',
  '#609E9A',
]
